export function clearFromHTML(text: string) {
  const tmp = document.createElement('div');
  tmp.innerHTML = text.replace('</li>', ' ');
  return tmp.textContent || tmp.innerText || '';
}
